import { http } from "@/utils";

const trainingClass = {
  /**
   * 获取公共班级
   * @param data
   * @return {*}
   */
  officialWebsiteTrainingClassId(data) {
    let url = "/uuos/official_website_training_class_id";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 公共班级的课程列表
   * @param data
   * @return {*}
   */
  officialWebsiteTrainingClassList(data) {
    let url = "/uuos/official_website_training_class_list";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 获取图片地址
   * @param data
   * @returns {Promise<Res>}
   */
  officialWebsiteGetPreviewUrl(data) {
    let url = '/uuos/official_website_get_preview_url';
    return http.post(url, data).then(res => res.data);
  },
  /**
   * 获取课程分类
   * @param data
   * @returns {Promise<Res>}
   */
  listCourseTypeByClass(data) {
    let url = '/uuos/list_course_type_by_class';
    return http.post(url, data).then(res => res.data);
  },
};

export default trainingClass;
